import React, { useState, useEffect } from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../app/LanguageContext';
import { getConsignmentSettings, saveConsignmentSettings } from './private/consignmentApi';
import { listOrderTypes } from '../../app/api';

function ConsignmentSettingsPage() {
  const { translate } = useTranslation();
  const [orderTypeId, setOrderTypeId] = useState('');
  const [orderTypes, setOrderTypes] = useState([]);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    const load = async () => {
      try {
        const [settResp, typesResp] = await Promise.all([
          getConsignmentSettings(),
          listOrderTypes(true),
        ]);
        setOrderTypeId(settResp?.data?.order_type_id || '');
        setOrderTypes(typesResp?.data?.order_types || typesResp?.data || []);
      } catch (e) {
        setSnackbar({ open: true, message: e.message, severity: 'error' });
      }
    };
    load();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await saveConsignmentSettings({ order_type_id: orderTypeId });
      setSnackbar({ open: true, message: translate('consignment.settings_saved'), severity: 'success' });
    } catch (e) {
      setSnackbar({ open: true, message: e.message, severity: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box p={2} maxWidth={600}>
      <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="subtitle1" fontWeight="bold">
          {translate('consignment.settings_title')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {translate('consignment.settings_order_type_description')}
        </Typography>
        <TextField
          select
          label={translate('consignment.settings_order_type')}
          value={orderTypeId}
          onChange={(e) => setOrderTypeId(e.target.value)}
          size="small"
          fullWidth
        >
          <MenuItem value="">{translate('common.none')}</MenuItem>
          {orderTypes.map((t) => (
            <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
          ))}
        </TextField>
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" onClick={handleSave} disabled={saving}>
            {saving ? <CircularProgress size={18} /> : translate('common.save')}
          </Button>
        </Box>
      </Paper>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default ConsignmentSettingsPage;
